import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { MatCardModule } from '@angular/material/card'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { MatIcon } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import {
  MatTable,
  MatTableDataSource,
  MatTableModule,
} from '@angular/material/table'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator'
import { MatProgressBar } from '@angular/material/progress-bar'
import { MatTabsModule } from '@angular/material/tabs'

import { MatTooltip } from '@angular/material/tooltip'
import { SubClientService } from '../../../core/services/customer/sub-client/sub-client.service'
import { FormClientSearchComponent } from '../../../shared/components/form-client-search/form-search.component'
import { TableListDisassociatedSubClientComponent } from '../../../shared/components/table-list-disassociated-sub-client/table-list-disassociated-sub-client.component'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MatDividerModule } from '@angular/material/divider'
import { cnpjTransform, responseDefaultForm } from '../../../shared/utils/utils'
import { ErrorRequestModel, ResponseRequestModel } from '../../../core/models/response.model'
import { EmployeeService } from '../../../core/services/employee/employee/employee.service'

@Component({
  selector: 'associate-consultant-operate-create',
  imports: [
    MatInputModule,
    MatPaginator,
    MatTableModule,
    MatPaginatorModule,
    MatProgressBar,
    MatCardModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    MatDividerModule,
    MatTabsModule,
    FormClientSearchComponent,
    TableListDisassociatedSubClientComponent,
    MatIcon,
    MatProgressSpinner,
    MatTooltip,
  ],
  templateUrl: './associate-consultant-operate-create.component.html',
  styleUrl: './associate-consultant-operate-create.component.scss',
  providers: [SubClientService],
  standalone: true,
})
export class AssociateConsultantOperateCreateComponent
  implements OnInit, AfterViewInit
{
  constructor(
    private snackbar: SnackbarCustomService,
    // private subClientService: SubClientService,
    private employeeService: EmployeeService,
  ) {}

  @Input() client: any = {}
  @Output() response = new EventEmitter()
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined
  @ViewChild('tableAssociate') table: MatTable<any> | undefined

  loadingBIcon: boolean = false

  item: any = {}

  displayedColumns: string[] = ['name', 'cpf','email', 'action']

  loadingClient: boolean = false
  pageClient: number = 1
  rowsClient: number = 10
  totalClient: number = 0
  listClient: any[] = []
  columnsClient: any[] = [
    {
      keyColumn: 'name',
      key: 'nome',
      description: 'Nome',
    },
    {
      keyColumn: 'cpf',
      key: 'cpf',
      description: 'Cpf',
    },
    {
      keyColumn: 'email',
      key: 'email',
      description: 'Email',
    },
    {
      keyColumn: 'action',
      key: { add: true, remove: false },
      description: 'Ações',
    },
  ]

  tableSource: MatTableDataSource<any> = new MatTableDataSource<any>()
  loadingAssociateClient: boolean = false
  rowsAssociateClient: number = 10
  listAssociateClient: any[] = []
  columnsAssociateClient: any[] = [
    {
      keyColumn: 'name',
      key: 'nome',
      description: 'Nome',
    },
    {
      keyColumn: 'cpf',
      key: 'cpf',
      description: 'Cpf',
    },
    {
      keyColumn: 'email',
      key: 'email',
      description: 'Email',
    },
    {
      keyColumn: 'action',
      key: { add: false, remove: true },
      description: 'Ações',
    },
  ]

  listSearch: any = [
    {
      id: 'nome',
      description: 'Nome',
      type: 'string',
      visible: true,
    },
    {
      id: 'cpf',
      description: 'Cpf',
      type: 'string',
      visible: true,
    },
    {
      id: 'matricula',
      description: 'Matrícula',
      type: 'string',
      visible: true,
    },
    {
      id: 'email',
      description: 'Email',
      type: 'string',
      visible: true,
    },
  ]

  inputSearchClient: any = { type: '', search: '' }
  searchFormClient: any = { search: false, model: {} }

  ngOnInit(): void {
    // this.treatClient(this.client)
    this.getClients()
    // this.getNotClientsByConsultant()
  }

  ngAfterViewInit() {
    this.refreshTable()
  }

  treatClient(client: any) {
    let list = []
    if (client) {
      list.push({
        ...client,
        tipo: client.tipoPessoaId == 1 ? 'Cliente Física' : 'Cliente Jurídica',
        documento_identificacao: cnpjTransform(client.cnpj),
        nome_desc: client.nomeFantasia,
      })
    }
    this.uploadListAssociate(list)
    this.tableSource.data = list
    this.refreshTable()
  }

  refreshTable() {
    if (this.paginator) {
      this.tableSource.paginator = this.paginator
    }
    if (this.table) {
      this.table.renderRows()
    }
  }

  treatResponseClient(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        list.push(item)
      }
    }
    // if (response.data) {
    //   for (let item of response.data) {
    //     list.push({
    //       ...item,
    //       tipo: item.tipoPessoaId == 1 ? 'Cliente Física' : 'Cliente Jurídica',
    //       documento_identificacao: cnpjTransform(item.cnpj),
    //       nome_desc: item.nomeFantasia,
    //       chosen: this.checkItens(item),
    //     })
    //   }
    // }
    this.listClient = list
    this.totalClient = response.totalItens
  }

  getClients() {
    this.loadingClient = true
      // this.subClientService
      // .listPagedSubClient(this.pageClient, this.rowsClient)
    this.employeeService.listPagedEmployeeConsultantOperate(this.pageClient, this.rowsClient)
      .subscribe({
        next: (response: any) => {
          this.treatResponseClient(response)
          this.loadingClient = false
        },
        error: (err: ErrorRequestModel) => {
          console.error(err)
          this.loadingClient = false
        },
        complete: () => {
          this.loadingClient = false
        },
      })
  }

  searchClients() {
    this.loadingClient = true
    // this.subClientService
    //   .searchPagedSubClient(
    //     this.pageClient,
    //     this.rowsClient,
    //     this.searchFormClient.model,
    //   )
    this.employeeService.searchAllPagedEmployee(this.pageClient, this.rowsClient, this.searchFormClient.model)
      .subscribe({
        next: (response: any) => {
          this.treatResponseClient(response)
          this.loadingClient = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loadingClient = false
        },
        complete: () => {
          this.loadingClient = false
        },
      })
  }

  uploadListClient(type: 'new' | '' = '') {
    if (type == 'new') {
      this.searchFormClient = { search: false, model: {} }
    }
    if (this.searchFormClient.search) {
      this.searchClients()
    } else {
      this.getClients()
    }
  }

  search(event: any) {
    if (event.search) {
      this.searchFormClient = {
        search: true,
        model: this.createModel(event.data),
      }
    }
    this.pageClient = 1
    this.uploadListClient(!event.search ? 'new' : '')
  }

  createModel(element: any) {
    let model: any = {
      pessoaId: 0,
      funcionarioFuncaoId: 1,
      statusId: 0,
    }
    for (let i = 0; i < this.listSearch.length; i++) {
      const item = this.listSearch[i]
      model[item.id] =
        item.id == element.type
          ? element.search
          : responseDefaultForm(item.type)
    }
    return model
  }

  pageChanged($event: any) {
    this.pageClient = $event.pageIndex + 1
    this.rowsClient = $event.pageSize
    this.uploadListClient()
  }

  addItem(element: any) {
    this.loadingBIcon = true
    const index = this.tableSource.data.findIndex((ele: any) => {
      return ele.id == element.id
    })
    if (index == -1) {
      this.tableSource.data.push(element)
      this.uploadListAssociate(this.tableSource.data)
    }
    this.loadingBIcon = false
    this.refreshTable()
    // this.updateListAssociate()
  }

  removeItem(element: any) {
    this.loadingBIcon = true
    const index = this.tableSource.data.findIndex((ele: any) => {
      return ele.id == element.id
    })
    if (index >= 0) {
      this.tableSource.data.splice(index, 1)
      this.uploadListAssociate(this.tableSource.data)
    }
    this.loadingBIcon = false

    this.refreshTable()
    // this.updateListAssociate()
  }

  checkItens(item: any) {
    const index = this.listClient.findIndex((ele: any) => {
      return ele.id == item.id
    })
    return index >= 0 ? true : false
  }

  uploadListAssociate(list: any) {
    let associateClient: number[] = []
    for (let i = 0; i < list.length; i++) {
      associateClient.push(list[i].id)
    }
    this.listAssociateClient = associateClient
    this.response.emit(this.listAssociateClient)
  }

  validClient(element: any) {
    if (element.id == this.client.id) {
      return false
    } else {
      return true
    }
  }
}
